import React from 'react';

const RequestTabContainer = ({ component, ...rest }) => {
  const TabComponent = component;
  return <TabComponent {...rest} />;
};

export default RequestTabContainer;
